export enum AppRegion {
  Global = 'GLOBAL',
  Cn = 'CN',
}
